import {BzTagTone} from "@bringoz/ui";
import {ThreePLProviderType} from "../../types/threePL-provider.type";

export const STATE_URL_ONLY_OPTIONS = {notify: false, reload: false};

export const THREE_PL_PROVIDER_TYPES: string[] = Object.values(ThreePLProviderType);

export const THREE_PL_STATUS_TONE: Record<string, BzTagTone> = {
  UNASSIGNED: "neutral", Unassigned: "neutral", Pending: "neutral", Draft: "neutral", NotScheduled: "neutral",
  ASSIGNED: "info", Assigned: "info", Scheduled: "info", Dispatched: "info", HeadingDestination: "info", ArrivedDestination: "info",
  STARTED: "primary", Started: "primary",
  COMPLETED: "success", Completed: "success", Delivered: "success", ManualHandled: "success",
  HeadingPickup: "warning", ArrivedPickup: "warning", PickedUp: "warning", OnHold: "warning",
  CANCELED: "danger", Canceled: "danger", Aborted: "danger", Failed: "danger", Rejected: "danger",
};
